<template>
  <v-dialog max-height="500" max-width="500" :value="visible" persistent>
    <v-card class="py-10 px-7">
      <CloseDialogButton :close="close" />
      <div class="align-center d-flex flex-column">
        <NoDeliveryIcon />
        <div class="font-size-lg mb-12 text-center">
          {{ renderDeliveryAddressStatusMessage() }}
        </div>
        <v-btn
          color="primary"
          height="48"
          width="180"
          rounded
          @click.stop="close"
        >
          <div class="font-size-md text-capitalize">Return to Order</div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { AddressState } from "@/types/address.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import NoDeliveryIcon from "@/elements/NoDeliveryIcon.vue";

/*
const deliveryAddressStatusMessages = {
  empty: "Please enter your delivery address first.",
  error: server,
  invalid: "Please pick from suggested addresses.",
  outside: "Your address is outside of the delivery area.",
};
*/
const deliveryAddressStatusMessage = {
  empty: "Please enter your delivery address first.",
  invalid: "Please pick from suggested addresses.",
  outside: "Your address is outside of the delivery area.",
};

export default {
  name: "DeliveryAddressStatusDialog",
  components: { CloseDialogButton, NoDeliveryIcon },
  computed: {
    ...mapState({
      deliveryErrorMessage: (state) => state.cart.deliveryErrorMessage,
    }),
  },
  methods: {
    renderDeliveryAddressStatusMessage() {
      return this.addressState === AddressState.error
        ? this.deliveryErrorMessage
        : deliveryAddressStatusMessage[this.addressState];
    },
  },
  props: { addressState: String, close: Function, visible: Boolean },
};
</script>
